import React, { useState, useEffect } from "react";
import { DeviceFrameset } from "react-device-frameset";
import "react-device-frameset/styles/marvel-devices.min.css";
import campaignService from '../../services/campaign.service'

function SmsPreview({id}) {
  const [txtContent,setTxtContent] = useState(null);
  useEffect(()=>{
    getSmsCampaign()
  },[])

  const getSmsCampaign= ()=>{
    campaignService.getCampaignById(id)
    .then(res=>{
      setTxtContent(res.data.content)
    })
    .catch(err=>{
      console.log(err)
    })
  }
  return (
    <>
    
      <DeviceFrameset device="iPhone X">
                <div
                  style={{
                    marginTop: "100px",
                    marginLeft: "30px",
                    padding: "15px",
                    display: "inline-block",
                    position: "relative",
                    width: "300px",
                    height: "auto",
                    backgroundColor: "lightyellow",
                    borderRadius: "30px",
                  }}
                >
               {txtContent && txtContent}
                </div>
              </DeviceFrameset>
    </>
  )
}

export default SmsPreview